// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-components-Widget-___Widget-module__container {
  position: relative;
  box-sizing: border-box;
  overflow: hidden;
  max-height: 100%;
  height: 100%;
  display: flex;
  align-items: row;
  flex-wrap: nowrap;
}

.app-components-Widget-___Widget-module__contentContainer {
  max-width: 100%;
  padding: 10px;
}

.app-components-Widget-___Widget-module__inner {
  position: relative;
  background-color: #fff;
  height: 100%;
  box-sizing: border-box;
  border: var(--mainBorder);
  max-height: 100%;
  height: 100%;
  width: 100%;
}

.app-components-Widget-___Widget-module__resize {
  width: 3px;
  height: 100%;
  position: absolute;
  z-index: 10;
  cursor: ew-resize;
  top: 0;
  right: 0;
}

.app-components-Widget-___Widget-module__resize:hover {
    width: 6px;
    background-color: lightgrey;
    margin-left: -3px;
  }

.app-components-Widget-___Widget-module__title {
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: bold;
}

.app-components-Widget-___Widget-module__resizeContainer {
  position: relative;
  width: 100%;
  height: 40px;
  border-top: 1px solid var(--mainBorderColor);
  cursor: pointer;
  z-index: 2;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}

.app-components-Widget-___Widget-module__resizeInner {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  height: 100%;
}

.app-components-Widget-___Widget-module__resizeContainer:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.app-components-Widget-___Widget-module__collapseOverlay {
  writing-mode: tb-rl;
  background-color: #ffffff;
  text-orientation: sideways;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
}

.app-components-Widget-___Widget-module__collapseTitle {
  transform: rotate(180deg);
  color: rgba(0, 0, 0, 0);
  font-size: bold;
  animation-delay: 0.5s;
  animation-duration: 0.5s;
  animation-name: app-components-Widget-___Widget-module__opacity;
  animation-fill-mode: forwards;
}

@keyframes app-components-Widget-___Widget-module__opacity {
  from {
    color: rgba(0, 0, 0, 0);
  }
  to {
    color: rgba(0, 0, 0, 1);
  }
}
`, "",{"version":3,"sources":["webpack://./app/components/Widget/Widget.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,MAAM;EACN,QAAQ;AAOV;;AALE;IACE,UAAU;IACV,2BAA2B;IAC3B,iBAAiB;EACnB;;AAGF;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,4CAA4C;EAC5C,eAAe;EACf,UAAU;EACV,yBAAiB;KAAjB,sBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,qBAAqB;EACrB,wBAAwB;EACxB,+DAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;AACF","sourcesContent":[".container {\n  position: relative;\n  box-sizing: border-box;\n  overflow: hidden;\n  max-height: 100%;\n  height: 100%;\n  display: flex;\n  align-items: row;\n  flex-wrap: nowrap;\n}\n\n.contentContainer {\n  max-width: 100%;\n  padding: 10px;\n}\n\n.inner {\n  position: relative;\n  background-color: #fff;\n  height: 100%;\n  box-sizing: border-box;\n  border: var(--mainBorder);\n  max-height: 100%;\n  height: 100%;\n  width: 100%;\n}\n\n.resize {\n  width: 3px;\n  height: 100%;\n  position: absolute;\n  z-index: 10;\n  cursor: ew-resize;\n  top: 0;\n  right: 0;\n\n  &:hover {\n    width: 6px;\n    background-color: lightgrey;\n    margin-left: -3px;\n  }\n}\n\n.title {\n  margin-bottom: 10px;\n  font-size: 16px;\n  font-weight: bold;\n}\n\n.resizeContainer {\n  position: relative;\n  width: 100%;\n  height: 40px;\n  border-top: 1px solid var(--mainBorderColor);\n  cursor: pointer;\n  z-index: 2;\n  user-select: none;\n}\n\n.resizeInner {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: row;\n  height: 100%;\n}\n\n.resizeContainer:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\n.collapseOverlay {\n  writing-mode: tb-rl;\n  background-color: #ffffff;\n  text-orientation: sideways;\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1;\n}\n\n.collapseTitle {\n  transform: rotate(180deg);\n  color: rgba(0, 0, 0, 0);\n  font-size: bold;\n  animation-delay: 0.5s;\n  animation-duration: 0.5s;\n  animation-name: opacity;\n  animation-fill-mode: forwards;\n}\n\n@keyframes opacity {\n  from {\n    color: rgba(0, 0, 0, 0);\n  }\n  to {\n    color: rgba(0, 0, 0, 1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `app-components-Widget-___Widget-module__container`,
	"contentContainer": `app-components-Widget-___Widget-module__contentContainer`,
	"inner": `app-components-Widget-___Widget-module__inner`,
	"resize": `app-components-Widget-___Widget-module__resize`,
	"title": `app-components-Widget-___Widget-module__title`,
	"resizeContainer": `app-components-Widget-___Widget-module__resizeContainer`,
	"resizeInner": `app-components-Widget-___Widget-module__resizeInner`,
	"collapseOverlay": `app-components-Widget-___Widget-module__collapseOverlay`,
	"collapseTitle": `app-components-Widget-___Widget-module__collapseTitle`,
	"opacity": `app-components-Widget-___Widget-module__opacity`
};
export default ___CSS_LOADER_EXPORT___;
